import { useTranslation } from 'react-i18next';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { MainMenuIcon, MenuContainer, TrashMenuButton } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import type { Point } from '@view-model/models/common/basic';
import { MenuSize } from '@view-model/models/sticky/ui';

type Props = {
  position: Point;
  onDownload(): void;
  onDelete?: () => void;
};

export const FileContainerMenu: React.FC<Props> = ({ position, onDownload, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <MenuContainer
      position={position}
      size={{ width: MenuSize * (onDelete ? 2 : 1), height: MenuSize }}
      positionOrigin="left-bottom"
    >
      <MainMenuBox
        menuSize={MenuSize}
        isSelected={false}
        onClick={onDownload}
        text={t('canvas.fileContainer.menu.download')}
      />
      <MainMenuIcon icon={faDownload} menuSize={MenuSize} />
      {onDelete && (
        <g transform={`translate(${MenuSize}, 0)`}>
          <TrashMenuButton menuSize={MenuSize} onClick={onDelete} text={t('common.action.delete')} />
        </g>
      )}
    </MenuContainer>
  );
};
